<template lang="html">
  <v-container grid-list-lg fluid class="pa-0">
    <v-layout row wrap>
      <v-flex
        xs12
        sm6
        xl4
        v-for="form in forms"
        v-if="!form.deleted"
        :key="form.id"
      >
        <v-card
          height="100%"
        >
          <v-img

            height="180px"
            :src="form.src"
          >
        </v-img>
          <v-card-title
            primary-title
            class="pb-0"
          >
            <div style="text-align: left">
              <h3 class="headline mb-0">{{form.title}}</h3>
              <p>{{form.subtitle}}</p>
            </div>
          </v-card-title>
          <v-card-actions
            class="pt-0"
          >
            <a
              :href="form.activeUrl"
              style="text-decoration: none"
            >
              <v-btn
                color="primary"
                fab
                flat
              >
                <v-icon color="primary">assignment</v-icon>
              </v-btn>
            </a>
            <v-btn
              color="primary"
              flat
              fab
              @click="copyToClipBoard(form.activeUrl)"
            ><v-icon>link</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn fab flat color="grey" @click="onEditForm(form.id)"><v-icon>edit</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        sm6
        xl4
      >
        <v-card
          height="350px"
        >
          <v-img
            height="180px"
            class="grey lighten-2"
            style="cursor: pointer"
            @click="onEditForm()"
          >
          <v-layout row wrap fill-height justify-center text-xs-center align-center>
            <v-flex xs12>
              <v-icon large>add</v-icon>
            </v-flex>
          </v-layout>
        </v-img>
          <v-card-text>
            <div class="grey lighten-3 pa-3 mt-3"></div>
            <div class="grey lighten-3 pa-1 mt-2"></div>
            <div class="grey lighten-3 pa-1 mt-2"></div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- Modals and popups -->
    <sp-form-edit-dialog
      v-bind="formEditorAttributes"
      v-on:dialog-state="formEditorAttributes.active=$event"
      ></sp-form-edit-dialog>
    <v-snackbar
      v-model="snackbar"
      color="primary"
      :timeout="6000"
      bottom
    >
     Link copied to clipboard!
     <v-btn
       color="white"
       flat
       fab
       @click="snackbar = false"
     >
       <v-icon>close</v-icon>
     </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'
import SpFormEditDialog from './FormEditDialog.vue'
export default {
  data () {
    return {
      snackbar: false,
      formEditorAttributes: {
        active: false, // controlls if dialog is up or not
        id: undefined
      }
    }
  },
  methods: {
    onEditForm (id) {
      this.formEditorAttributes.id = id
      this.formEditorAttributes.active = true
    },
    copyToClipBoard (str) {
      const el = document.createElement('textarea')
      el.value = str
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.snackbar = true // notifiy user
    }
  },
  computed: {
    ...mapGetters('tools/forms/', [
      'forms'
    ])
  },
  components: {
    SpFormEditDialog
  },
  mounted () {
    // fetch the forms from firebase
    this.$store.dispatch('tools/forms/fetchForms')
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/pages/Tools/Forms/Forms.vue